"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/VIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_247)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_247`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00171 0H30.0018V24H-6.00171V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.9644 11.6941L18.3781 18.5643C18.3007 18.705 18.357 18.8808 18.5046 18.9581C18.6453 19.0355 18.8211 18.9792 18.8984 18.8316L22.4847 11.9614C22.555 11.8137 22.4918 11.6379 22.3441 11.5746C22.2034 11.5113 22.0417 11.5605 21.9644 11.6941Z",
					fill: "#1583C4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.4706 13.22L18.4062 18.5221C18.3147 18.6557 18.3499 18.8385 18.4835 18.9299C18.603 19.0143 18.7718 18.9932 18.8703 18.8807L22.9347 13.5786C23.0332 13.452 23.0121 13.2692 22.8785 13.1708C22.7519 13.0653 22.5691 13.0934 22.4706 13.22Z",
					fill: "#1583C4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.6493 12.7489L18.364 18.5924C18.3077 18.7401 18.378 18.9159 18.5327 18.9722C18.6804 19.0284 18.8562 18.9581 18.9125 18.8034L21.1978 12.9599C21.2471 12.8052 21.1697 12.6434 21.015 12.5872C20.8673 12.545 20.7126 12.6153 20.6493 12.7489Z",
					fill: "#1583C4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.58432 12.0879C2.61245 12.2075 2.66871 12.4184 2.73903 12.6856C2.85857 13.1357 2.99217 13.5857 3.13281 14.0006C3.29455 14.4858 4.16651 16.2086 4.55327 16.7501C5.03847 17.4322 5.54477 18.1073 6.06513 18.7612C6.17764 18.8948 6.38157 18.9089 6.51518 18.7964C6.64175 18.6839 6.66285 18.494 6.5644 18.3604C6.05107 17.7135 5.5518 17.0525 5.07363 16.3774C4.77829 15.9696 3.86414 14.1905 3.73756 13.7967C3.53363 13.1849 3.35784 12.5591 3.20313 11.9332C3.16797 11.7645 2.99921 11.6519 2.83044 11.6871C2.66167 11.7223 2.54916 11.891 2.58432 12.0598C2.57729 12.0739 2.58432 12.0809 2.58432 12.0879Z",
					fill: "#409347"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.8901 8.07972C14.8901 8.07972 13.6525 3.00969 12.3516 3.00969C11.8664 3.00969 11.5148 2.9675 11.2686 3.45974C11.2054 3.57928 9.81304 3.34723 9.92555 4.92238C9.96071 5.40758 10.0029 4.23325 10.9733 4.68329C11.4163 4.89425 9.82007 8.07269 9.82007 8.07269H14.8901V8.07972Z",
					fill: "#FFD836",
					stroke: "#231F20",
					strokeWidth: .0703194,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M26.7741 3.40346L20.382 4.95049C15.087 6.23733 17.4216 8.07267 17.4216 8.07267L12.3516 8.9165L7.28155 8.07267C7.28155 8.07267 9.61615 6.23733 4.3211 4.95049L-2.07093 3.40346C-2.97101 3.18547 -3.32261 3.64255 -2.81631 4.43013C-2.81631 4.43013 4.67973 11.7433 6.10018 12.3059C7.52064 12.8755 8.96921 12.3059 8.96921 12.3059C8.96921 12.3059 7.92145 12.9177 7.28155 13.9936C6.63461 15.0694 6.95808 16.4336 4.54613 16.8204C4.15937 17.2845 4.19453 17.8049 4.75005 18.2198C5.30558 18.6276 9.82008 14.8374 9.82008 14.8374C9.82008 14.8374 8.13241 16.5532 8.13241 17.3759C8.13241 17.7346 11.2335 21.1591 12.3586 21.1591C13.4837 21.1591 16.5848 17.7346 16.5848 17.3759C16.5848 16.5532 14.8971 14.8374 14.8971 14.8374C14.8971 14.8374 19.4116 18.6276 19.9672 18.2198C20.5227 17.8119 20.7688 16.8626 20.1641 16.8204C18.1951 16.6938 18.0756 15.0694 17.4286 13.9936C16.7817 12.9177 15.741 12.3059 15.741 12.3059C15.741 12.3059 17.1895 12.8755 18.61 12.3059C20.0305 11.7363 27.5195 4.43013 27.5195 4.43013C28.0258 3.64255 27.6812 3.18547 26.7741 3.40346Z",
					fill: "#FFD836",
					stroke: "#231F20",
					strokeWidth: .0703194,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.15356 7.86169V13.5083C8.15356 16.7219 12.3516 17.7064 12.3516 17.7064C12.3516 17.7064 16.5497 16.7219 16.5497 13.5083V7.86169H8.15356Z",
					fill: "white",
					stroke: "#231F20",
					strokeWidth: .0703194,
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.83423 9.68298V16.5251C10.4108 16.947 11.0297 17.2423 11.5149 17.4322V9.68298H9.83423ZM14.8691 9.68298V16.5251C14.2925 16.947 13.6737 17.2423 13.1885 17.4322V9.68298H14.8691Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.15356 7.86169H16.5497V10.5268H8.15356V7.86169Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.77553 14.8022L-3.31552 10.7167H-4.89771L-2.66155 16.3985H-0.889501L1.32556 10.7167H-0.256627L-1.77553 14.8022ZM25.7475 10.6815H27.0765V16.4266H25.7475V10.6815Z",
					fill: "#1583C4"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_247`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as VIFlag };
